import React from 'react';
import styled from 'styled-components';
import { formatPrice } from '@app/helpers';
import { Thumbnail, Text, Skeleton } from '@bb/elements-web';
import type { ListingData } from '../types';

type ListingInfoProps = {
  loading?: boolean;
  listing: Partial<ListingData>;
};

const ListingInfo: React.FC<ListingInfoProps> = ({
  loading,
  listing: {
    thumbnail,
    line1,
    line2,
    city,
    province,
    postal_code,
    list_price,
    type,
  } = {},
}) => (
  <StyledWrapper data-cy="listing-info">
    <Thumbnail dataCy="listing-thumbnail" src={thumbnail} />
    <StyledInnerDiv>
      <div>
        {loading ? (
          <Skeleton title={false} paragraph={{ rows: 3, width: 100 }} />
        ) : (
          <Text size="large" dataCy="listing-address">
            {line1} {line2}
          </Text>
        )}
      </div>
      <div>
        {!loading && (
          <Text size="large" dataCy="listing-location">
            {city}, {province} {postal_code}
          </Text>
        )}
      </div>
      <div>
        {!loading && (
          <Text size="large" dataCy="listing-price">
            {formatPrice(list_price ?? 0, type ?? 'condo')}
          </Text>
        )}
      </div>
    </StyledInnerDiv>
  </StyledWrapper>
);

const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 16px;
`;

const StyledInnerDiv = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;

  div:nth-child(3) {
    margin-top: 12px;
  }
`;

export default ListingInfo;
